/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * PolicyService.ts
 */

import Policy from "../tools/provider/Policy";
import StandardPolicy from "../provider/StandardPolicy";
import AdminPolicy from "../provider/AdminPolicy";
import DefaultPolicy from "../tools/provider/DefaultPolicy";
import {Listener, Service} from "../tools/service/Service";
import UserService, {UserListener} from "./UserService";
import User from "../models/User";
import ManagerPolicy from "../provider/ManagerPolicy";
import {Role} from "../tools/model/enumerations/Role";

export interface PolicyListener extends Listener<PolicyListener> {
    policyUpdated(policy: Policy): void;
}

export default class PolicyService extends Service<Policy, PolicyListener> implements UserListener {
    private _userService: UserService;
    public static id = "PolicyService"

    constructor(userService: UserService) {
        super();

        this._userService = userService;
        this._policy = new DefaultPolicy();
    }

    private _policy: Policy;

    public get policy(): Policy {
        return this._policy;
    }

    /**
     * start
     */
    public start() {
        super.start()
        this._userService.addListener(this);

        this._refreshPolicy(this._userService.user);
    }

    /**
     * stop
     */
    public stop() {
        this._userService.removeListener(this);
    }

    /**
     * _notifyListeners
     * @return {Promise<void>}
     */
    private _notifyListeners = () => {
        this.listeners.forEach((l) => l.policyUpdated(this._policy))
    };

    /**
     * _refreshPolicy
     * @returns {DefaultPolicy | StandardPolicy | AdminPolicy}
     * @private
     * @param user
     */
    private _refreshPolicy(user?: User) {
        if (user) {
            if (user.roles.indexOf(Role.ADMIN) !== -1) {
                this._policy = new AdminPolicy();
            } else if (user.roles.indexOf(Role.MANAGER) !== -1) {
                this._policy = new ManagerPolicy();
            } else if (user.roles.indexOf(Role.STANDARD) !== -1) {
                this._policy = new StandardPolicy();
            }
        } else {
            this._policy = new DefaultPolicy();
        }

        this._notifyListeners();
    }

    /**
     * currentUserHasBeenUpdated
     * @param user
     */
    public currentUserHasBeenUpdated(user: User | undefined): void {
        this._refreshPolicy(user)
    }
}